import { appRoutes } from "./routes/routes";
import "./App.css";
import {  Suspense } from "react";
import { BrowserRouter, useRoutes } from "react-router-dom";
import Spinner from "./Container/spinner";

function AppRouter(){
  const element = useRoutes(appRoutes);
  return element
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter >
        <Suspense fallback={<Spinner />}>
         <AppRouter />
        </Suspense>
      </BrowserRouter>
    </div>
  );
}
